import { Box, Typography } from '@wishket/design-system';

import { PATH } from '@/shared/constants';
import { Image } from '@/shared/Components';
import { getCurrentDate } from '@/shared/utils';

const TrendingContentsHeader = () => {
  const { month, week } = getCurrentDate();

  return (
    <Box className="flex items-center gap-1.5 desktop:h-[30px]">
      <Typography
        variant="subTitle2"
        className="font-bold text-w-gray-900 desktop:typo-subTitle1"
      >
        {`${month}월 ${week}주 인기`}
      </Typography>
      <Image
        src={`${PATH.MEDIA_YOZM_IMAGE}/graph_popular.gif`}
        width={24}
        height={24}
        alt="graph_popular"
        unoptimized
      />
    </Box>
  );
};

export default TrendingContentsHeader;
